// App-side delegate for `@heidi/templates/data`.
// isAuthenticated crosses the package seam as a plain boolean.
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import {
  useQueryCommunityTemplateBatchLikeStatus as useQueryCommunityTemplateBatchLikeStatusCore,
  useQueryCommunityTemplateLikeStatus as useQueryCommunityTemplateLikeStatusCore,
} from '@heidi/templates/data';

export function useQueryCommunityTemplateLikeStatus(templateId: string) {
  const { isAuthenticated } = useIsAuthenticated();
  return useQueryCommunityTemplateLikeStatusCore(templateId, isAuthenticated);
}

export function useQueryCommunityTemplateBatchLikeStatus(templateIds: string[]) {
  const { isAuthenticated } = useIsAuthenticated();
  return useQueryCommunityTemplateBatchLikeStatusCore(templateIds, isAuthenticated);
}
